import React, { useState, useEffect, useContext, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import ErrorDialogModal from '../ErrorDialogModal';
import { BsFillEyeFill, BsFillEyeSlashFill, BsExclamationCircle } from "react-icons/bs";
import ReusableButton from '../../buttons/reusableButton';
import UserPrefContext from '../../../../context/userPrefContext';
import AuthContext from '../../../../context/authContext';
import classes from './AddDiagnosis.module.css'
import styles from './AddNewUserModal2.module.css'

function AddNewUserModal2(props) {


    const userPrefCtx = useContext(UserPrefContext);
    const authCtx = useContext(AuthContext);

    const inputRefs = useRef({});
   
    const [errors, setErrors] = useState({})
    const [showError, setShowError] = useState(false)
    const [showPassword, setShowPassword] = useState(false);

    const formFields = [
        {
            name: "first_name",
            type: "text",
            display_name: "First Name",
            required: true,
        },
        {
            name: "last_name",
            type: "text",
            display_name: "Last Name",
            required: true,
        },
        {
            name: "email",
            type: "email",
            display_name: "Email",
            required: true,
        },
        {
            name: "password",
            type: "password",
            display_name: "Password",
            required: true,
        },
        {
            name: "preferred_username",
            type: "text",
            display_name: "Preferred Username",
            required: true,
        },
    ]


    const [item, setItem] = useState(formFields.reduce((acc, curr) => {
        acc[curr] = '';
        return acc;
    }))



    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const onClose = () => {
        setErrors({})
        props.close()
    }

    const ValidateForm = () => {
        // check if required fields are populated
        let not_populated = []
        let theErrors = {}

        // create array of required fields
        const required = formFields.filter(f => !!f.required)

        required.forEach(field => {
            if (!!field) {
                const value = inputRefs.current[field.name].value
                if (!!!value) {
                    // no value - add to the list of fields with error
                    not_populated.push(inputRefs.current[field.name])
                    // theErrors.push(`${field.display_name} is required`)
                    theErrors[field.name] = `${field.display_name} is required`
                }

            }
        })

        setErrors(theErrors)
        // console.log("continue_if_no_errors", continue_if_no_errors)
        return {fields: not_populated, messages: theErrors}
    }



    const postAddUser = () => {
        const validationResult = ValidateForm()
        if (validationResult.fields.length > 0) {
            return
        }

        const createUser = async (body) => {
            const postUserURL = process.env.REACT_APP_SERVER + `/api/v1/users/`

            const responseData = await fetch(postUserURL, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userPrefCtx.bearerToken}`,
                    auth: authCtx.authMode
                },
            })
            .then((res) => res.json())
            .then((data) => {
                //console.log(data);
                //props.close();
                props.closeAndUpdateParent(data);
            })
            .catch((err) => {
                console.log(err.message);
                setShowError(true);
            });
        }

        let postBody = {}
        formFields.forEach(f => {
            postBody = {...postBody, [f.name]: inputRefs.current[f.name].value.toString()}
        })

        console.log("postBody", postBody)
        createUser(postBody)
    }

    const resetFieldErrors = (field) => {
        const newErrors = {...errors}
        newErrors[field.name] = null

        setErrors({...newErrors})
    }

    const renderField = (f) => {
        return (
            <>
                {(f.type === 'text' || f.type === 'email') &&
                <>
                    <Form.Control 
                        id={f.name} 
                        type={f.type} 
                        defaultValue={item[f.name] ?? ''}
                        ref={(el) => inputRefs.current[f.name] = el}
                        onChange={e => {
                            resetFieldErrors(f)
                            setItem({...item, [f.name]: e.target.value ?? ''})
                        }}
                        className={`${!!errors[f.name] ? styles.err : ''}`}
                    />
                    {!!errors[f.name] ?
                        <div className={styles['invalid-feedback-override']}>
                            <BsExclamationCircle /> {errors[f.name]}
                        </div>
                        :
                        <div className={styles['form-field-info']}>
                            {f.info ?? ''}
                        </div>
                    }
                </>
                }

                {(f.type === 'password') &&
                <>
                    <div className="password-input-container">
                        <Form.Control 
                            id={f.name} 
                            type={showPassword ? 'text' : 'password'}
                            // defaultValue={item[f.name] ?? ''}
                            ref={(el) => inputRefs.current[f.name] = el}
                            // onChange={e => {
                            //     resetFieldErrors(f)
                            //     setItem({...item, [f.name]: e.target.value ?? ''})
                            // }}
                            className={`${!!errors[f.name] ? styles.err : ''}`}

                        />
                        <div className="password-toggle-dashboard" onClick={togglePasswordVisibility}>
                            {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                        </div>

                        {!!errors[f.name] ?
                            <div className={styles['invalid-feedback-override']}>
                                <BsExclamationCircle /> {errors[f.name]}
                            </div>
                            :
                            <div className={styles['form-field-info']}>
                                {f.info ?? ''}
                            </div>
                        }
                    </div>
                </>
                }
            </>
        )
    }


    return (
        <>
            <ErrorDialogModal
                setOpen={showError}
                close={() => setShowError(false)}
                componentName="Add New User"
            />
            <Modal 

                size="lg"
                show={props.setOpen} 
                onHide={props.close} 
                animation={false}
                backdrop="static"
                //style={{ zIndex: '9999'}}
                //dialogClassName={{ zIndex: '9999'}}
                dialogClassName={classes.custom_modal}
                style={{ visibility: (showError) ? 'hidden' : 'visible' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formFields.map(f => {
                        return (
                            <div key={f.name}>
                                {/* <label 
                                    htmlFor={f.name} 
                                    className={styles.field_header}
                                >
                                    {f.display_name}{!!f.required ?<sup className={styles.sup}>*</sup>:''}
                                </label> */}
                            <p>{f.display_name}{!!f.required ?<sup className={styles.sup}>*</sup>:''}</p>  
                                {renderField(f)}
                            </div>
                        )

                    })}
                

                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={postAddUser}>
                    Save Changes
                </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddNewUserModal2
